import useQueryParams from '../../../navigation-utils/useQueryParams';
import { useDispatch, useSelector } from 'react-redux';
import { useRunOnceWhenTruthy } from '../../common/useRunOnceWhenTruthy';
import { openPredefinedConfigurationCard } from '../../../reducers/documentationReducer';
import useObjectTypesWithFetch from '../../../hooks/useObjectTypesWithFetch';
import { selectParserInfo } from '../../../reducers/global/globalReducer';
import useParser from '../../parser/useParser';
import { DeepLinkSearchParams } from '@server/deep-link-search-params';
import useSweepNavigate from '../../../navigation-utils/useSweepNavigate';

export const useSetDataFromQueryParams = (crmOrgId: string) => {
  const query = useQueryParams();
  const dispatch = useDispatch();

  const { objectTypesByName } = useObjectTypesWithFetch({ crmOrgId });
  const { parseObjectOnDemand } = useParser({ crmOrgId });
  const { removeQueryParams } = useSweepNavigate();

  const parserInfo = useSelector(selectParserInfo(crmOrgId));

  const configurationItemId = query.get(DeepLinkSearchParams.configurationItemId);
  const objectName = query.get(DeepLinkSearchParams.objectName);
  const apexClassParentId = query.get(DeepLinkSearchParams.apexClassParentId);
  const objectType = objectTypesByName[objectName ?? ''];
  const parsedObjectNames = parserInfo?.parserObjects?.map((objectTypeName) => objectTypeName.name);
  const [configurationType, configurationName] = configurationItemId?.split('|') ?? [];

  useRunOnceWhenTruthy(
    () => {
      if (objectType && configurationName && configurationType) {
        if (!parsedObjectNames?.includes(objectType.objectType)) {
          parseObjectOnDemand(objectType.objectType);
        }

        dispatch(
          openPredefinedConfigurationCard({
            objectType,
            configurationName,
            configurationType,
            apexClassParentId,
          }),
        );
        removeQueryParams([DeepLinkSearchParams.apexClassParentId]);
      }
    },
    !!(configurationName && objectType && configurationType) && !!apexClassParentId,
  );
  return !!(configurationName && objectType && configurationType && apexClassParentId);
};
